import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'

export default class Regions extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	render() {
		let {roles} = this.props;
		const {data, pages, limit, loading} = this.state;
		const columns =
			[
				{
					Header: "Rank",
					accessor: "ranking",
					width: 80
				},
				{
					Header: "Name",
					accessor: "name",
				},
				{
					Header: "Radius",
					accessor: "radius",
				},
				{
					Header: "Latitude",
					accessor: "latitude",
				},
				{
					Header: "Longitude",
					accessor: "longitude",
				},
				{
					Header: "Walk Rank",
					accessor: "metro_walk_ranking",
					width: 120
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						return (
							<span>
								<Link to={"/regions/" + props.original.pkey}>
									<Button color="green-meadow" size={"sm"} block={true}>
										<Edit fontSize={'small'}/></Button>
								</Link>
							</span>
						);
					}
				},
			]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Regions')}
							{this.renderHeaderRight("Regions", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: 'ranking'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
